import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SubscriptionGuard = ({ data, children, onLogout, tenantId }) => {
  const navigate = useNavigate();

  
  if (String(tenantId) === '1') return children;


  if (
    !data || 
    data.subscription_status === 'loading' || 
    typeof data.subscription_status === 'undefined'
  ) {
    return children; 
  }


  if (data.subscription_status !== 'active') {
    return (
      <div style={{
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh',
        background: '#0b0e14', 
        zIndex: 9999, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center', 
        padding: '20px', 
        color: '#fff'
      }}>
        <ShieldAlert size={80} className="text-danger mb-4" />
        <h1 className="fw-bold mb-2">SUBSCRIPTION INACTIVE</h1>
        <p className="text-secondary mb-4" style={{ maxWidth: '450px' }}>
          Access to AI-NOC data is locked because your subscription has expired or was canceled.
        </p>
        <div className="d-flex gap-3">
          <button 
            className="btn btn-info px-5 fw-bold shadow-info" 
            onClick={() => navigate('/subscription')}
          >
            RENEW NOW
          </button>
          <button 
            className="btn btn-outline-secondary" 
            onClick={onLogout}
          >
            LOGOUT
          </button>
        </div>
      </div>
    );
  }


  return children;
};

export default SubscriptionGuard;